import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import TableComponent from "../common/TableComponent";
import { getAllBadgeData, getBadgesDelete } from "../../api";
import { useSelector } from "react-redux";
import { Button, Modal } from "react-bootstrap";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import { Toast } from "primereact/toast";

function Badges() {
  const { token } = useSelector((state) => state.profileReducer);
  const [allBadgeData, setAllBadgeData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [allFilterData, setAllFilterData] = useState([]);
  const [show, setShow] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  const categoryObj = {
    1: "Active Member of The Loop",
    2: "The Loop Hall of Fame Excellence Inductee",
    3: "The Loop Hall of Fame Gold Inductee",
    4: "The Loop Hall of Fame Silver Inductee",
    5: "Super Looper of the Month",
    6: "Most Popular Looper of the Month",
    7: "Happy Looper Anniversary",
    8: "Special Contributor of The Loop",
    9: "Scholar Looper",
  };

  const colourObj = {
    1: "Magenta",
    2: "Blue",
    3: "Yellow",
    4: "Green",
    5: "Red",
    6: "Grey",
    7: "Orange",
    8: "Pink",
    9: "Purple",
  };

  const toast = useRef(null);

  const tableColumnTitles = [
    {
      name: "Sr.No",
      // field: "Sr.No",
      isSortFilter: false,
      isAction: true,
    },
    {
      name: "User",
      field: "User",
      isSortFilter: true,
      isAction: false,
    },
    {
      name: "Category",
      field: "Category",
      isSortFilter: true,
      isAction: false,
    },
    {
      name: "Title",
      field: "Title",
      isSortFilter: true,
      isAction: false,
    },
    {
      name: "Color",
      field: "Color",
      isSortFilter: true,
      isAction: false,
    },
    { name: "Action", isSortFilter: false, isAction: true },
  ];

  const getBadgesDataFromAPI = async () => {
    setIsLoading(true);
    getAllBadgeData(token)
      .then((res) => {
        setIsLoading(false);
        setAllBadgeData(res?.data?.data);
        setAllFilterData(res?.data?.data);
      })
      .catch((err) => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    async function getAllAPI() {
      await getBadgesDataFromAPI();
    }
    getAllAPI();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const deleteBadges = (id) => {
    setIsLoading(true);
    setShow(false);
    getBadgesDelete(id, token)
      .then((res) => {
        setIsLoading(false);
        toast.current.show({
          severity: "success",
          summary: `${res?.data?.message}`,
        });
        setTimeout(async () => {
          getBadgesDataFromAPI();
        }, 2000);
      })
      .catch((err) => {
        setIsLoading(false);
        toast.current.show({
          severity: "err",
          summary: `${err?.data?.message}`,
        });
      });
  };

  // Filtering
  const updateResponseData = (searchData) => {
    searchData.map((ele) => {
      if (ele.searchField !== "") {
        if (ele?.searchValue !== "") {
          switch (ele.searchField) {
            // case "Sr No":
            //   const dataSrNo = allFilterData.filter((item) =>
            //     item?.index + 1?.includes(ele.searchValue)
            //   );
            //   setAllNewsData(dataSrNo);
            //   break;
            case "User":
              const dataUser = allFilterData.filter((item) => {
                const regx = new RegExp(`${ele.searchValue.toLowerCase()}`);
                const fullName =
                  item?.user?.first_name.trim().toLowerCase() +
                  " " +
                  item?.user?.last_name.trim().toLowerCase();
                return regx.test(fullName);
              });
              setAllBadgeData(dataUser);
              break;
            case "Category":
              const datacat = allFilterData.filter((item) => {
                const tempArr = [];
                Object.entries(categoryObj).forEach((entry) => {
                  const regx = new RegExp(`${ele.searchValue.toLowerCase()}`);
                  const [key, value] = entry;
                  const found = regx.test(value.toLowerCase());
                  if (found) {
                    tempArr.push(key);
                  }
                });
                return tempArr.includes(item.category);
              });
              setAllBadgeData(datacat);
              break;
            case "Title":
              const dataTitle = allFilterData.filter((item) =>
                item?.title
                  ?.toLowerCase()
                  ?.includes(ele.searchValue?.toLowerCase())
              );
              setAllBadgeData(dataTitle);
              break;
            case "Color":
              const datacolor = allFilterData.filter((item) => {
                const tempArr = [];
                Object.entries(colourObj).forEach((entry) => {
                  const regx = new RegExp(`${ele.searchValue.toLowerCase()}`);
                  const [key, value] = entry;
                  const found = regx.test(value.toLowerCase());
                  if (found) {
                    tempArr.push(+key);
                  }
                });
                return tempArr.includes(item.color);
              });
              setAllBadgeData(datacolor);
              break;

            default:
              break;
          }
        } else {
          setAllBadgeData(allFilterData);
        }
      }
      return "";
    });
  };

  const adminTableRequests = (ele, index) => {
    return (
      <>
        <tr className="table-light">
          <td>{index + 1}</td>
          <td>{ele?.user?.first_name + " " + ele?.user?.last_name || "-"}</td>
          <td>
            {ele?.category === "1"
              ? "Active Member of The Loop"
              : ele?.category === "2"
              ? "The Loop Hall of Fame Excellence Inductee"
              : ele?.category === "3"
              ? "The Loop Hall of Fame Gold Inductee"
              : ele?.category === "4"
              ? "The Loop Hall of Fame Silver Inductee"
              : ele?.category === "5"
              ? "Super Looper of the Month"
              : ele?.category === "6"
              ? "Most Popular Looper of the Month"
              : ele?.category === "7"
              ? "Happy Looper Anniversary"
              : ele?.category === "8"
              ? "Special Contributor of The Loop"
              : ele?.category === "9"
              ? "Scholar Looper"
              : "-"}
          </td>
          <td>{ele?.title ? ele?.title : "-"}</td>
          <td>
            {ele?.color === 1
              ? "Magenta"
              : ele?.color === 2
              ? "Blue"
              : ele?.color === 3
              ? "Yellow"
              : ele?.color === 4
              ? "Green" && "Grey"
              : ele?.color === 5
              ? "Red"
              : ele?.color === 6
              ? "Grey"
              : ele?.color === 7
              ? "Orange"
              : ele?.color === 8
              ? "Pink"
              : ele?.color === 9
              ? "Purple"
              : "-"}
          </td>
          <td>
            <Link
              to={{
                pathname: "/badges/ViewBadges",
                search: `?badgesId=${ele.id}`,
              }}
              aria-expanded="false"
              data-toggle="collapse"
              className="action-link "
            >
              <svg
                width="20"
                height="14"
                viewBox="0 0 20 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="me-2"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M19.3377 6.7875C17.8352 2.90106 14.164 0.28158 10.0002 0.125C5.83641 0.28158 2.1652 2.90106 0.662722 6.7875C0.613077 6.92482 0.613077 7.07518 0.662722 7.2125C2.1652 11.0989 5.83641 13.7184 10.0002 13.875C14.164 13.7184 17.8352 11.0989 19.3377 7.2125C19.3874 7.07518 19.3874 6.92482 19.3377 6.7875ZM6.25 7C6.25 4.92893 7.92893 3.25 10 3.25C12.0711 3.25 13.75 4.92893 13.75 7C13.75 9.07107 12.0711 10.75 10 10.75C7.92893 10.75 6.25 9.07107 6.25 7ZM7.5 7C7.5 8.38071 8.61929 9.5 10 9.5C10.663 9.5 11.2989 9.23661 11.7678 8.76777C12.2366 8.29893 12.5 7.66304 12.5 7C12.5 5.61929 11.3807 4.5 10 4.5C8.61929 4.5 7.5 5.61929 7.5 7ZM1.91897 7C3.18772 10.1687 6.68772 12.625 10.0002 12.625C13.3127 12.625 16.8127 10.1687 18.0815 7C16.8127 3.83125 13.3127 1.375 10.0002 1.375C6.68772 1.375 3.18772 3.83125 1.91897 7Z"
                  fill="black"
                />
              </svg>
            </Link>
            <Link
              aria-expanded="false"
              data-toggle="collapse"
              className="action-link "
              // onClick={() => deleteUser(ele.id)}
              onClick={() => {
                setDeleteId(ele.id);
                setShow(true);
              }}
            >
              <svg
                width="16"
                height="18"
                viewBox="0 0 16 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M10.5 0.25H5.5V1.5H10.5V0.25ZM0.5 2.75V4H1.75V16.5C1.75 17.1904 2.30964 17.75 3 17.75H13C13.6904 17.75 14.25 17.1904 14.25 16.5V4H15.5V2.75H0.5ZM3 16.5V4H13V16.5H3ZM5.5 6.5H6.75V14H5.5V6.5ZM10.5 6.5H9.25V14H10.5V6.5Z"
                  fill="#212121"
                />
              </svg>
            </Link>
          </td>
        </tr>
      </>
    );
  };

  return (
    <>
      <Toast ref={toast} />

      {isLoading && (
        <div className="set-proper-line-in-all-page">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}

      {show && (
        <Modal
          show={show}
          onHide={() => setShow(false)}
          className="logout-modal"
          centered
        >
          <Modal.Header closeButton></Modal.Header>
          <Modal.Body className="modal-title text-center">
            Are you sure you want to delete this badges?
          </Modal.Body>
          <Modal.Footer className="border-0 justify-content-center">
            <Button
              variant="secondary"
              className="me-3 yes-btn-cls-add"
              onClick={() => {
                deleteBadges(deleteId);
                getBadgesDataFromAPI();
              }}
            >
              Yes
            </Button>
            <Button
              variant="secondary"
              className="no-btn-cls-add"
              onClick={() => {
                setDeleteId(null);
                setShow(false);
              }}
            >
              No
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      <div className="content-section badges-section">
        <div className="card main-user-card">
          <div className="row m-0">
            <div className="col-lg-12 mt-4 p-0 mr-2 d-flex justify-content-between align-items-center mu-less-up-side">
              <div className="title-heading">Badges</div>
              <div className="right_section_action">
                <Link to="/badges/AddBadges">
                  <button className="btn fill_btn float-right apply-btn-cls">
                    Add Badges
                  </button>
                </Link>
              </div>
            </div>
          </div>
          <TableComponent
            tableColumnTitles={tableColumnTitles}
            tabRequests={allBadgeData}
            tableRowRequests={adminTableRequests}
            updateResponseData={updateResponseData}
          />
        </div>
      </div>
    </>
  );
}

export default Badges;
